import "./border.css";

const Border = () => <div className="border"></div>;

export default Border